import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import type { CardStack } from "@shared/models/card-stack"
import type { Course } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import copyAllLessonsForDayAction from "cc-frontend/lib/actions/planbook/lessons/PLANBOOK_COPY_ALL_LESSONS_FOR_DAY"
import { getCardStackIdForDate } from "cc-frontend/lib/unit-utils"
import type Dispatcher from "cc-frontend/services/dispatcher"
import type EmberStore from "cc-frontend/services/ember-store"
import type ModalManager from "cc-frontend/services/modal-manager"
import type Session from "cc-frontend/services/session"
import _ from "lodash"
import { cloneDeep, compact, map } from "lodash-es"
import moment from "moment"

@tagName("")
export default class DayMenuPrimaryMenuComponent extends Component {
  //args
  courses!: Array<Course>
  planbook!: Planbook
  dateString!: string
  closeMenu!: Function
  isFilteringClasses!: boolean
  hiddenCourseIds!: Array<string>

  //services
  @service("ember-store") store!: EmberStore
  @service dispatcher!: Dispatcher
  @service session!: Session
  @service modalManager!: ModalManager

  @action
  copyLessonsForDay() {
    this.closeMenu()

    if (this.session.isAuthenticated !== true || this.session.userId === null) {
      this.session.mustSignInToProceed("Copy Lessons for Day")
      return
    }

    let lessonsForCourses = compact(
      map(this.courses, (course) => {
        let cardStackId = getCardStackIdForDate(course.attributes.calendar.dates, this.dateString)
        let cardStack: CardStack = this.store.findInMemory("card-stack", cardStackId)
        if (cardStack) {
          let attrs = cloneDeep(cardStack.attributes)
          attrs.parentCardStack = {
            id: cardStack.id,
            version: cardStack.attributes.version,
            planbookId: this.planbook.id,
            courseId: course.id,
            ownerIds: [this.planbook.relationships.owner.data.id],
            source: "paste",
          }
          return {
            courseId: course.id,
            cardStackAttrs: attrs,
          }
        } else {
          return undefined
        }
      }),
    )
    this.dispatcher.dispatchPreparedAction(
      copyAllLessonsForDayAction({
        currentUserId: this.session.userId,
        lessonsForCourses: lessonsForCourses,
        dateString: this.dateString,
        ownerIds: [this.planbook.relationships.owner.data.id],
        planbookId: this.planbook.id,
      }),
    )
  }

  @action
  printOrDownload() {
    this.closeMenu()

    if (this.session.isAuthenticated !== true) {
      this.session.mustSignInToProceed("Print/Download Day")
      return
    }

    if (_.includes(this.session.user.content.meta.permissions, "can-print-day")) {
      this.modalManager.openModal("planner/modals/print-download", {
        courseIds: _.chain(this.courses)
          .map((course) => course.id)
          .reject((courseId) => _.includes(this.hiddenCourseIds, courseId))
          .value(),
        planbookId: this.planbook.id,
        startDate: this.dateString,
        endDate: this.dateString,
        layout: "planbook-date:single",
        currentUserId: this.session.userId,
        isFilteringClasses: this.isFilteringClasses,
        canPrint: _.includes(this.session.user.content.meta.permissions, "can-print-day"),
        dateRangeString: moment(this.dateString).format("dddd, MMMM Do YYYY"),
      })
    } else {
      this.modalManager.openModal("planner/modals/print-paywall", {})
    }
  }
}
